<div class="dashboard-container">
  <app-my-profit></app-my-profit>
  <app-dashboard-table></app-dashboard-table>
</div>
